import type { CityConfig } from "../city-template/types";

export const clintonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Clinton",
  state: "Mississippi",
  stateAbbr: "MS",
  slug: "clinton",
  route: "/clinton",
  title: "Emergency Passport Clinton, MS — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Clinton, MS — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving the Jackson metro area, Mississippi College students, Hinds County families, and state government professionals throughout central Mississippi.",
  h1: "Emergency & Expedited Passport Services in Clinton, MS",
  heroSubtitle: "Mississippi College study-abroad program starting in three weeks? State government trade mission to Brazil booked for next month? Olde Towne family vacation to Europe departing soon? We help Clinton residents — from MC professors to Jackson metro commuters to Hinds County families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Charming%20Olde%20Towne%20Clinton%20Mississippi%20with%20historic%20brick%20streets%20lined%20with%20majestic%20oak%20trees%20draped%20in%20Spanish%20moss%2C%20traditional%20Southern%20small-town%20architecture%20featuring%20colorful%20historic%20storefronts%20and%20vintage%20lampposts%2C%20Mississippi%20College%20red%20brick%20campus%20buildings%20visible%20in%20distance%2C%20warm%20golden%20afternoon%20sunlight%20casting%20long%20shadows%2C%20peaceful%20suburban%20Southern%20atmosphere%20with%20deep%20blue%20sky%20and%20soft%20white%20clouds%2C%20high%20quality%20editorial%20architectural%20photography%20style%20with%20rich%20warm%20tones%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=clinton-hero-2026&orientation=landscape",
  heroImageAlt: "Historic Olde Towne Clinton Mississippi with oak trees and traditional Southern architecture",
  geoPosition: "32.3415;-90.3218",
  geoPlacename: "Clinton, Mississippi",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Located ~380 miles east in downtown Atlanta — approximately 5.5 hours drive from Clinton. Appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Clinton", zips: "39056, 39058" },
    { name: "Jackson", zips: "39201–39298" },
    { name: "Ridgeland", zips: "39157, 39158" },
    { name: "Madison", zips: "39110, 39130" },
    { name: "Byram", zips: "39272" },
    { name: "Flowood", zips: "39232" },
    { name: "Pearl", zips: "39208" },
    { name: "Brandon", zips: "39042, 39043" },
    { name: "Canton", zips: "39046" },
    { name: "Vicksburg", zips: "39180–39183" },
    { name: "Raymond", zips: "39154" },
    { name: "Bolton", zips: "39041" },
  ],
  benefits: [
    { icon: "ri-graduation-cap-line", title: "Mississippi College Student Specialists", desc: "MC study abroad programs, faculty sabbaticals, and international conferences — we guide Clinton students and professors through expedited passport processing with campus-friendly turnaround times." },
    { icon: "ri-building-2-line", title: "Jackson Metro & State Government Ready", desc: "State employees, legislators, and Jackson metro professionals trust us for trade missions, government travel, and last-minute international obligations." },
    { icon: "ri-flight-takeoff-line", title: "JAN Airport Expertise", desc: "Jackson-Medgar Wiley Evers International Airport connects through ATL, DFW, and IAH to worldwide destinations. We time your passport processing around your connecting flight itinerary." },
    { icon: "ri-home-heart-line", title: "Hinds County Family Expedited", desc: "From Olde Towne families to countryside residents, we handle first-time passports, child applications, and family vacation planning with step-by-step guidance." },
  ],
  internalLinks: [
    { name: "Fast passport services in Jackson, MS", route: "/jackson" },
    { name: "Expedited passport in Memphis, TN", route: "/memphis" },
    { name: "Quick passport services in New Orleans, LA", route: "/neworleans" },
    { name: "Mississippi passport services overview", route: "/mississippi" },
  ],
  fpcOfficeAddress: "100 W Leake St, Clinton, MS 39056",
  fpcOfficeNote: "Fast Passport Center serves Clinton and the Jackson metro area via secure registered courier with direct submission to U.S. Department of State processing centers. Our registered couriers hand-deliver your documents — meaning faster results without driving 3 hours to the New Orleans Passport Agency. Clinton residents can ship from any UPS Store, FedEx Office, or post office location across Hinds County and the Jackson metro.",
  fpcOfficeDistance: "Serving Clinton, Jackson, Ridgeland, Madison, Byram, Flowood, Pearl, Brandon, Canton, Vicksburg, and all Hinds County, Madison County, and Rankin County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Clinton, the Jackson metropolitan area, and central Mississippi. From Mississippi College students on the Clinton campus to state government employees in downtown Jackson, from Ridgeland and Madison families to Byram and Flowood commuters — we serve all of Hinds County, Madison County, and Rankin County. Our courier service eliminates the need to drive 3 hours to New Orleans for passport agency services.",
  nearbyCitiesIntro: "We serve Clinton and all Jackson metro communities including Jackson, Ridgeland, Madison, Byram, Flowood, Pearl, Brandon, and Canton. We also serve Mississippi College students and faculty who need expedited passports for study abroad programs, international conferences, and academic travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Clinton as simple as possible — with the efficiency and reliability Jackson metro professionals, Mississippi College students, and Hinds County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Clinton travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Clinton and Jackson metro travelers encounter unique passport challenges — from Mississippi College study-abroad deadlines to last-minute state government travel to 6-month validity rules catching travelers off guard. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Clinton travelers — from Mississippi College professors to Jackson metro families to Hinds County professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Clinton, MS? Here are the most common ones we hear from Jackson metro-area travelers.",
  statePageRoute: "/states/mississippi",
  statePageName: "Mississippi",
  servicesIntro: "Whether you need a renewal before a JAN connecting flight to London, an emergency passport for a last-minute state government trip, or a first-time passport for a Mississippi College study-abroad semester — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dps.ms.gov/driverservices",
  dmvLabel: "Mississippi DPS — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission availability", "Predictable turnaround you can count on", "Ideal for Mississippi College study abroad", "Document review included — we catch errors", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission availability", "Faster than self-service post office", "Good for planned family travel", "Document review included — we catch errors", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload and wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["170 miles to Atlanta Passport Agency — 5+ hour drive", "Appointment required — no walk-ins accepted", "Life-or-death emergencies only with proof of travel", "Bereavement or medical crisis documentation required", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
      emergencyDescription: "The nearest regional passport agency is in Atlanta — approximately 380 miles east (about a 5.5-hour drive from Clinton). Appointments are required for life-or-death emergencies only, and walk-ins are not accepted.",
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "JAN connecting flight to London in two days? State government trade mission departing this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Clinton and Jackson metro travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Clinton residents renew fast — no agency visit required for most renewals. Perfect for Mississippi College professors, Jackson metro professionals, and Hinds County families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Clinton residents through every step — from the Olde Towne area to the Jackson metro — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Mississippi College study abroad or Jackson metro business trip stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation or Mississippi College family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Jackson metro professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Mississippi state government officials, Jackson metro executives, and consultants who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Clinton and Jackson metro travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Clinton MS", description: "Urgent passport processing for Clinton Mississippi travelers with immediate departure needs from Jackson-Medgar Wiley Evers International Airport." },
    { name: "Expedited Passport Renewal Clinton MS", description: "Fast passport renewal for Clinton Mississippi residents with a previously-issued passport." },
    { name: "First-Time Passport Clinton MS", description: "New passport application services for Clinton Mississippi residents applying for their first passport." },
    { name: "Child Passport Clinton MS", description: "Minor passport services for Clinton Mississippi families with children under 16." },
    { name: "Name Change Passport Clinton MS", description: "Passport name correction after marriage, divorce, or legal name changes for Clinton residents." },
    { name: "Second Passport Clinton MS", description: "Second passport services for Mississippi state government officials and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Dr. Patricia W.",
      location: "Clinton, MS",
      rating: 5,
      text: "I needed my passport renewed for an academic conference in London with only 10 days notice. Fast Passport Center got it done in 4 days. The document review caught an issue I never would have noticed. Outstanding service for Mississippi College faculty.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "James L.",
      location: "Madison, MS",
      rating: 5,
      text: "Our state department had a trade mission to Brazil and I needed an emergency passport. They processed everything remotely and I had it in 48 hours. No driving to New Orleans — everything handled from my home office.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah M.",
      location: "Clinton, MS",
      rating: 5,
      text: "My daughter is studying abroad in Spain next semester through Mississippi College. The student passport process was seamless — they even helped coordinate the acceptance facility appointment at the Clinton Post Office. Highly recommend.",
      service: "Child Passport",
    },
    {
      name: "The Thompson Family",
      location: "Ridgeland, MS",
      rating: 5,
      text: "We booked a last-minute family trip to Cancun and realized two of our kids' passports had expired. Fast Passport Center walked us through everything, and both passports arrived in 5 days. Incredible family-friendly service.",
      service: "Child Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "clinton-1",
      name: "Clinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 W Leake St",
      city: "Clinton",
      state: "MS",
      zip: "39056",
      phone: "(601) 924-5511",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Clinton",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Clinton residents. Convenient for Mississippi College students and Olde Towne area families. Passport photos available on-site. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-2",
      name: "Jackson Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "401 E South St",
      city: "Jackson",
      state: "MS",
      zip: "39201",
      phone: "(601) 353-6243",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, walk-ins available",
      distance: "Downtown Jackson — ~10 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1377543",
      websiteLabel: "USPS Location",
      notes: "Full-service passport acceptance facility in downtown Jackson. Serves state government employees and Jackson metro residents. Walk-in hours subject to clerk availability — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-3",
      name: "Ridgeland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "805 S Pear Orchard Rd",
      city: "Ridgeland",
      state: "MS",
      zip: "39157",
      phone: "(601) 853-4331",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Ridgeland — ~15 miles northeast",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Convenient for Ridgeland and Madison residents. Passport photos available. Limited appointment slots — schedule at least a week in advance during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-4",
      name: "Madison County Chancery Clerk",
      type: "County Clerk Passport Acceptance",
      address: "146 W Center St",
      city: "Canton",
      state: "MS",
      zip: "39046",
      phone: "(601) 859-1177",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Canton — ~25 miles northeast",
      website: "https://www.madison-co.com/",
      websiteLabel: "Madison County",
      notes: "County clerk office serving Madison County residents including Madison, Ridgeland, and Canton. By appointment only. No photo services on-site — bring your own passport photos.",
      icon: "ri-government-line",
    },
    {
      id: "clinton-5",
      name: "Hinds County Chancery Clerk",
      type: "County Clerk Passport Acceptance",
      address: "316 S President St",
      city: "Jackson",
      state: "MS",
      zip: "39201",
      phone: "(601) 968-6501",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Jackson — ~12 miles east",
      website: "https://www.hindscountyms.com/",
      websiteLabel: "Hinds County",
      notes: "Serves Hinds County residents including Clinton, Jackson, Byram, and Raymond. Appointment recommended. Call ahead for current passport acceptance hours and availability.",
      icon: "ri-government-line",
    },
    {
      id: "clinton-6",
      name: "Pearl Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2421 Old Brandon Rd",
      city: "Pearl",
      state: "MS",
      zip: "39208",
      phone: "(601) 936-7950",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, walk-ins available",
      distance: "Pearl — ~20 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1387618",
      websiteLabel: "USPS Location",
      notes: "Serves Pearl, Brandon, and eastern Jackson metro communities. Walk-in capacity limited — arrive early for best availability. Passport photos available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 3 hours to New Orleans Passport Agency in downtown New Orleans", fpc: "Most Clinton travelers ship documents overnight — no long drive needed" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options for any travel timeline" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays — we catch errors before submission" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option — we give you a real timeline" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation — MC students, state employees, families" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping, logistics, and the 3-hour drive", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "Mississippi-Specific Guidance", agency: "Generic — no Mississippi College, JAN airport, or Jackson metro expertise", fpc: "Full Jackson metro / MC / state government / Hinds County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming New Orleans Agency Takes Walk-Ins",
      description: "The Atlanta Passport Agency requires appointments even for emergencies — and it is a 5.5-hour drive from Clinton. Many Jackson metro residents drive down only to be turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Clinton applicants often attempt the simpler renewal form when their passport was issued at age 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many drugstores and big-box retailers near Clinton produce photos that fail State Department standards — wrong size, wrong background, or shadows. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Mississippi College families and Jackson metro parents frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Passport Validity Rule",
      description: "Clinton travelers booking to Europe, Asia, or South America often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately before you book non-refundable tickets.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long on Study Abroad Deadlines",
      description: "Mississippi College students often wait until the last minute — after program acceptance — to apply for a passport. With 6–8 week standard processing, this creates unnecessary panic. We expedite so you never miss orientation.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or Mississippi College dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation — whether it's a study abroad semester or a family vacation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Clinton clients ship from the Clinton Post Office on Leake Street or a nearby UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 3 hours to New Orleans or wait at a Jackson post office hoping for an opening." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty so you can focus on packing." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Clinton, MS?", a: "We offer Clinton-area clients expedited processing as fast as 24 hours for emergency situations. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays — especially important for Mississippi College students on tight study-abroad timelines." },
    { q: "Do I need to visit a Clinton office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (like the Clinton Post Office at 100 W Leake St or the Jackson Main Post Office downtown), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Clinton address." },
    { q: "Where can I get a passport acceptance in the Jackson metro area?", a: "The Jackson metro has acceptance facilities at the Clinton Post Office, Jackson Main Post Office, Ridgeland Post Office, Pearl Post Office, as well as the Hinds County and Madison County Chancery Clerk offices. We maintain an updated list of area facilities with hours, photo availability, and appointment options." },
    { q: "Is there a passport agency closer than New Orleans?", a: "The Atlanta Passport Agency is the closest regional passport agency to Clinton — approximately 170 miles south (about a 3-hour drive). However, it only serves travelers with life-or-death emergencies and requires an appointment. For most Clinton and Jackson metro travelers, our registered courier service is faster and more accessible than driving to New Orleans." },
    { q: "What is the best price for expedited passport service near Clinton?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee — you will not find a better deal from any registered courier." },
    { q: "What documents do Clinton applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Clinton-specific checklist tailored to your situation." },
    { q: "Do you serve the entire Jackson metro area?", a: "Yes. We serve Clinton, Jackson, Ridgeland, Madison, Byram, Flowood, Pearl, Brandon, Canton, and all surrounding Hinds County, Madison County, and Rankin County communities. Our service is fully remote — we help travelers across the entire Jackson metropolitan area." },
    { q: "Can you help with Mississippi College study abroad passports?", a: "Absolutely. Mississippi College students studying abroad make up a significant portion of our Clinton-area clients. We understand MC's academic calendar, program deadlines, and the acceptance-to-departure timeline. We guide students through the entire process — from the acceptance facility visit to expedited processing." },
    { q: "How do I check my passport status from Clinton?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Clinton to final return shipping typically matches your chosen speed tier — we keep you informed throughout." },
    { q: "Can I renew my passport without visiting an office?", a: "If your current passport was issued within the last 15 years and you were 16 or older at the time, you can renew by mail without an office visit. We handle the expedited courier submission — no trip to the post office required for eligible renewals." },
    { q: "What about passports for state government employees?", a: "We regularly assist Mississippi state government employees with expedited passports for international trade missions, diplomatic travel, and official government business. We understand the urgency and documentation requirements specific to government travel and can coordinate tight timelines around official departure dates." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Clinton", address: "500 Hwy 80 E, Clinton, MS 39056", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Clinton", address: "201 Morrison Dr, Clinton, MS 39056", hours: "Call for hours", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "The UPS Store — Clinton", address: "101 Hwy 80 E, Clinton, MS 39056", hours: "Call for hours", website: "https://www.theupsstore.com/", websiteLabel: "UPS Store" },
    { name: "CVS Pharmacy — Jackson (County Line Rd)", address: "1000 County Line Rd, Jackson, MS 39211", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Ridgeland", address: "7000 Old Canton Rd, Ridgeland, MS 39157", hours: "Call for hours", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "FedEx Office — Jackson", address: "1000 Highland Colony Pkwy, Ridgeland, MS 39157", hours: "Call for hours", website: "https://www.fedex.com/en-us/office/passport-photos.html", websiteLabel: "FedEx Office" },
    { name: "CVS Pharmacy — Madison", address: "1000 Hwy 51, Madison, MS 39110", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart Photo Center — Clinton", address: "1001 Hwy 80 E, Clinton, MS 39056", hours: "Daily 9 AM – 7 PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Mississippi DPS — Jackson (Clinton Area)",
      address: "1900 E Woodrow Wilson Ave, Jackson, MS 39216",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, state IDs. About 15 minutes from Clinton. Appointment recommended.",
      featured: true,
    },
    {
      name: "Mississippi DPS — Pearl",
      address: "3851 Hwy 80 E, Pearl, MS 39208",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Full-service DPS driver license office serving Rankin County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "JAN",
      name: "Jackson-Medgar Wiley Evers International Airport",
      distance: "About 20 miles east of Clinton",
      address: "100 International Dr, Jackson, MS 39208",
      note: "Primary airport serving the Jackson metro area. Connections through Atlanta (ATL), Dallas-Fort Worth (DFW), Houston (IAH), and Charlotte (CLT) to international destinations worldwide. Convenient for Clinton, Jackson, and central Mississippi travelers.",
      flightUrl: "https://www.janairport.com/",
      flightLabel: "JAN Airport Website",
      featured: true,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Mississippi State Department of Health Vital Records. Online, mail, or in-person options available for Hinds County residents.",
      url: "https://msdh.ms.gov/msdhsite/_static/31,0,109.html",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Mississippi Vital Records. Required for estate and legal matters in Hinds County and the Jackson metro area.",
      url: "https://msdh.ms.gov/msdhsite/_static/31,0,109.html",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Hinds County Circuit Clerk or Mississippi Vital Records. Certified copies available for name changes and legal purposes.",
      url: "https://www.hindscountyms.com/circuit-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Hinds County Chancery Clerk. Required for name change passport corrections after divorce.",
      url: "https://www.hindscountyms.com/chancery-clerk",
    },
  ],
};